import { useEffect } from "react";

/**
 * Component that preloads avatar images in the background
 * to improve rendering performance when avatars are displayed
 */
export const AvatarPreloader = ({
	pendingReviewMRs = [],
	myOpenMRs = [],
	recentlyClosedMRs = [],
}) => {
	useEffect(() => {
		// Collect all unique avatar URLs from all MRs
		const avatarUrls = new Set();

		// Helper function to extract avatar URLs from an array of MRs
		const extractAvatarUrls = (mrList) => {
			for (let i = 0; i < mrList.length; i++) {
				const mr = mrList[i];

				// Add author avatar if exists
				if (mr.author?.avatarUrl) {
					avatarUrls.add(mr.author.avatarUrl);
				}

				// Add approver avatars if they exist
				if (Array.isArray(mr.approvers)) {
					for (let j = 0; j < mr.approvers.length; j++) {
						const approver = mr.approvers[j];
						if (approver.avatarUrl) {
							avatarUrls.add(approver.avatarUrl);
						}
					}
				}
			}
		};

		// Extract avatar URLs from all MR lists
		extractAvatarUrls(pendingReviewMRs);
		extractAvatarUrls(myOpenMRs);
		extractAvatarUrls(recentlyClosedMRs);

		// Preload images in the background using link elements
		const preloadLinks = [];

		// Convert Set to Array for iteration
		const urlsArray = Array.from(avatarUrls);

		for (let i = 0; i < urlsArray.length; i++) {
			const url = urlsArray[i];
			if (!url) continue;

			// Create a link element for preloading
			const link = document.createElement("link");
			link.rel = "preload";
			link.as = "image";
			link.href = url;

			// Add to document head
			document.head.appendChild(link);

			// Keep track of links to remove them later
			preloadLinks.push(link);
		}

		// Clean up function to remove preload links when component unmounts
		return () => {
			for (let i = 0; i < preloadLinks.length; i++) {
				const link = preloadLinks[i];
				if (link && document.head.contains(link)) {
					document.head.removeChild(link);
				}
			}
		};
	}, [pendingReviewMRs, myOpenMRs, recentlyClosedMRs]);

	// This component doesn't render anything visible
};

export default AvatarPreloader;
